import React, {ReactElement} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import InformationCard from '../InformationCard/InformationCard';
import Paragraph, {FontWeight} from '../Text/Paragraph/Paragraph';

import './OurProductsInformationBox.scss';

interface Props {
  bordered?: boolean;
  className?: string;
}

function OurProductsInformationBox({bordered, className}: Props): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <InformationCard
      className={`ourProductsInformationBox ${className || ''}`.trim()}
      header={formatMessage({id: 'homepage.ourProducts.links.informationBox.title'})}
      conditions={[
        {
          id: 'rate',
          label: formatMessage({id: 'homepage.ourProducts.links.informationBox.conditions.box1.title'}),
          description: formatMessage({id: 'homepage.ourProducts.links.informationBox.conditions.box1.text'}),
        },
        {
          id: 'repayment',
          label: formatMessage({id: 'homepage.ourProducts.links.informationBox.conditions.box2.title'}),
          description: formatMessage({id: 'homepage.ourProducts.links.informationBox.conditions.box2.text'}),
        },
      ]}
      bordered={bordered}
    >
      <Paragraph fontWeight={FontWeight.SEMIBOLD}>
        <FormattedMessage id="homepage.ourProducts.links.informationBox.description.title" />
      </Paragraph>
      <FormattedMessage id="homepage.ourProducts.links.informationBox.description" />
    </InformationCard>
  );
}

export default OurProductsInformationBox;
